var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.svg#seat-kott';
                    var viewUrl = 'svg/global.svg#view-seat-kott';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 106 56',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };